export const Configs = {
  DefaultPageIndex: 1,
  DefaultPageSize: 5,
};
export const URLConfig = {
  api_url:"http://dongtrieusmartcity-api.c2tech.vn"
}
